import * as _ from 'lodash';
import { FontSizeHelper } from './font-size-helper';
var FontStyleHelper = /** @class */ (function () {
    function FontStyleHelper() {
    }
    FontStyleHelper.isBold = function (fontStyle) {
        return fontStyle && fontStyle.indexOf(FontStyleHelper.textBold) !== -1;
    };
    FontStyleHelper.isItalic = function (fontStyle) {
        return fontStyle && fontStyle.indexOf(FontStyleHelper.textItalic) !== -1;
    };
    FontStyleHelper.fontSize = function (fontStyle) {
        if (!fontStyle) {
            return null;
        }
        var isBold = this.isBold(fontStyle) ? 1 : 0;
        var isItalic = this.isItalic(fontStyle) ? 1 : 0;
        return fontStyle.split(' ')[isBold + isItalic];
    };
    FontStyleHelper.fontFamily = function (fontStyle) {
        if (!fontStyle) {
            return null;
        }
        var isBold = this.isBold(fontStyle) ? 1 : 0;
        var isItalic = this.isItalic(fontStyle) ? 1 : 0;
        var fontSettings = fontStyle.split(' ');
        var fontFamilyIndex = isBold + isItalic + 1;
        return fontSettings.length > fontFamilyIndex ? fontSettings[fontFamilyIndex] : null;
    };
    FontStyleHelper.buildFontStyle = function (isBold, isItalic, fontSize, fontFamily) {
        if (!fontFamily) {
            fontFamily = FontStyleHelper.defautFontFamily;
        }
        var fontStyle = fontSize + ' ' + fontFamily;
        // bold & Italic must at the head of font style
        if (isBold) {
            fontStyle = FontStyleHelper.textBold + ' ' + fontStyle;
        }
        if (isItalic) {
            fontStyle = FontStyleHelper.textItalic + ' ' + fontStyle;
        }
        return fontStyle;
    };
    FontStyleHelper.getDefaultFontStyle = function () {
        return FontSizeHelper.defaultFontSize + ' ' + FontStyleHelper.defautFontFamily;
    };
    FontStyleHelper.dropPx = function (value) {
        if (_.endsWith(value, 'px')) {
            return Number(value.substring(0, value.length - 2));
        }
        else {
            return Number(value);
        }
    };
    FontStyleHelper.addPx = function (value) {
        var _value = String(value);
        if (_value.substring(_value.length - 2, _value.length) === 'px') {
            return _value;
        }
        else {
            return _value + 'px';
        }
    };
    FontStyleHelper.updateDropdownDisplayValue = function (value, obj) {
        if (!obj) {
            return;
        }
        var dropdown = obj;
        if (dropdown) {
            dropdown.writeValue(value);
        }
    };
    FontStyleHelper.fontSizeValidate = function (value) {
        if (Number(value) <= 0 || isNaN(Number(value))) {
            return { fontSizeError: true };
        }
        else {
            return undefined;
        }
    };
    FontStyleHelper.limitInputIsNumber = function (event) {
        var keyCode = event.which || event.keyCode;
        var specialkey = [8, 37, 39].some(function (key) { return key === keyCode; });
        if ((keyCode >= 48 && keyCode <= 57) || specialkey || (keyCode >= 96 && keyCode <= 105)) {
            event.returnValue = true;
        }
        else {
            event.returnValue = false;
        }
    };
    FontStyleHelper.defautFontFamily = 'Microsoft YaHei';
    FontStyleHelper.defaultFontColor = '#333';
    FontStyleHelper.textBold = 'bold';
    FontStyleHelper.textItalic = 'Italic';
    return FontStyleHelper;
}());
export { FontStyleHelper };
